import { Column, Row } from "components/styles";
import LocationIcon from "icons/LocationIcon";
import { TextData } from "views/components/Schedules/components/UpdateActivityPopup/styles";
import { FieldIconWrapper } from "views/components/Schedules/styles";

const SpaceLocationData = ({ space }) => {
	const { campus, spaceType, name } = space;
	const description = `${spaceType}: ${name}`;
	return (
		<Row
			width="100%" 
			gap="10px" 
			justifyContent="flex-start"
			wrap="no-wrap">
			<FieldIconWrapper>
				<LocationIcon/>
			</FieldIconWrapper>
			<Column width="max-content" gap="6px">
				<TextData weight="bold" title={campus}>{campus}</TextData>
				<TextData title={description}>{description}</TextData>
			</Column>
		</Row>
	);
}

export default SpaceLocationData;